import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'POST_ALL',
        delete: 'POST_DELETE'
      },
      permission: {
        query: 'system:post:query',
        add: 'system:post:add',
        edit: 'system:post:edit',
        remove: 'system:post:remove'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'post_name',
        label: '岗位名称',
        minWidth: '100px',
        fixed: 'left'
      }, {
        prop: 'post_code',
        label: '岗位编码',
        minWidth: '100px'
      }, {
        prop: 'post_sort',
        label: '显示顺序',
        minWidth: '100px',
        show: false
      }, {
        prop: 'status',
        label: '状态',
        width: '100px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "status",
              "value": row.status
            }
          });
        },
        show: false
      }, {
        prop: 'remark',
        label: '备注',
        width: '100px',
        show: false
      }, {
        prop: 'create_by',
        label: '创建人员',
        width: '100px',
        show: false
      }, {
        prop: 'created_at',
        label: '创建时间',
        width: '200px',
        formatter: function formatter(row) {
          return utils.time.format1(row.created_at, 'YYYY/M/D HH:mm:ss');
        },
        show: false
      }, {
        prop: 'update_by',
        label: '更新人员',
        width: '100px',
        show: false
      }, {
        prop: 'updated_at',
        label: '更新时间',
        width: '200px',
        formatter: function formatter(row) {
          return utils.time.format1(row.updated_at, 'YYYY/M/D HH:mm:ss');
        },
        show: false
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref2) {
        var row = _ref2.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: "\u786E\u5B9A\u5220\u9664 [ ".concat(row.post_name, " ] \u5417"),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'post_name',
        label: '岗位名称',
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:100px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.post_name,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "post_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        label: '状态',
        default: this.$env.VUE_APP_DICT_EMPTY_NUMBER,
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "status",
              "button": true,
              "all": true
            },
            "model": {
              value: _this3.search.form.model.status,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "status", $$v);
              }
            }
          });
        }
      }];
    }
  }
};